import { render, staticRenderFns } from "./CompanyJurisdications.vue?vue&type=template&id=a7f1f212&scoped=true"
import script from "./CompanyJurisdications.vue?vue&type=script&lang=js"
export * from "./CompanyJurisdications.vue?vue&type=script&lang=js"
import style0 from "./CompanyJurisdications.vue?vue&type=style&index=0&id=a7f1f212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f1f212",
  null
  
)

export default component.exports